module.exports = __webpack_public_path__ + "static/media/OrthoThumb.7e1cb540.png";